import BaseModelAPI from '../BaseModelAPI';

export default class PartDestination extends BaseModelAPI {
	static entity = 'partdestination';
	static entityName = 'partdestination';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.customerId = '';
			this.customer = {};
			this.partId = '';
			this.part = {};
			this.destinationId = '';
			this.destination = {};
			this.vendorId = '';
			this.vendor = {};
			this.vendorName = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}